import clsx from "clsx";

import css from "./overlay.module.scss";

interface OverlayProps {
  open: boolean;
  onClick: () => void;
  className?: string;
  "data-testid"?: string;
}

export function Overlay({ open, onClick, className, ...rest }: OverlayProps) {
  return (
    <div
      className={clsx(css.overlay, open && css.open, className)}
      onClick={onClick}
      {...rest}
    />
  );
}
